import { render, staticRenderFns } from "./GroupName.vue?vue&type=template&id=a2b19c6e&scoped=true&"
import script from "./GroupName.vue?vue&type=script&lang=js&"
export * from "./GroupName.vue?vue&type=script&lang=js&"
import style0 from "./GroupName.vue?vue&type=style&index=0&id=a2b19c6e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b19c6e",
  null
  
)

export default component.exports